export default __webpack_public_path__ + "static/media/mood.73487625.mp3";